import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useDeletePlanTerminationConfigQuery = () => {
  const { mutateAsync, isLoading, isSuccess } = useMutation((id: string) =>
    api.delete(API_URL.PLANS_TERMINATION_PROPERTIES_BY_PLAN_ID(id))
  );
  return {
    cancelTermination: mutateAsync,
    isLoading,
    isSuccess,
  };
};
